module.exports = __webpack_public_path__ + "static/media/Jemaime_5_Men_Essential Cotton Shorts.130bb5e1.jpeg";